import 'core-js/stable';
import 'regenerator-runtime/runtime';
import cssVars from 'css-vars-ponyfill';

import Vue from 'vue';
import axios from 'axios';
import router from './router';
import Vuesax from 'vuesax';
import VueSweetalert2 from 'vue-sweetalert2';

import {Avatar, Card, DatePicker, Icon} from 'ant-design-vue';

import App from './App.vue';

import 'vuesax/dist/vuesax.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './main.scss';

Vue.use(Vuesax);
Vue.use(VueSweetalert2);
Vue.use(Card);
Vue.component(Avatar.name, Avatar);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Icon.name, Icon);

Vue.prototype.$http = axios;
Vue.prototype.recaptcha_site_key = process.env.VUE_APP_RECAPTCHA_KEY;
Vue.prototype.automation_active = process.env.VUE_APP_AUTOMATION_ACTIVE ? process.env.VUE_APP_AUTOMATION_ACTIVE : 'no';
Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_API_BASE;

Vue.prototype.getErrorMessage = (catchError) => {
  let messageError = 'Something went wrong. Try again.'
  
  if(catchError.response?.data?.messages) {
    const listErrors = Object.values(catchError.response?.data?.messages)
    if(listErrors instanceof Array) {
      messageError = '<ul>'
      for(let errorItem of listErrors) {
        messageError += `<li>${errorItem instanceof Array ? '<li>'+errorItem.join('</li><li>')+'</li>' : errorItem}</li>`
      }
      messageError += '</ul>'
    }
  } else {
    messageError = catchError.response?.data?.message ? catchError.response.data.message : (catchError.response?.data?.error && catchError.response?.data?.error?.message ? catchError.response?.data?.error?.message : (catchError instanceof Error ? catchError.message : 'Something went wrong. Try again.'));
  }
  return messageError
}

cssVars();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
